export const fileToBase64 = async (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = () => {
    if (typeof reader.result !== 'string') {
      reject(new Error('Failed to convert file to base64'));
      return;
    }

    const [, base64 = ''] = reader.result.split(',');

    resolve(base64);
  };

  reader.onerror = () => {
    reject(new Error('Failed to read file'));
  };

  reader.readAsDataURL(file);
});
